import { Indicator as MantineIndicator, IndicatorProps as MantineIndicatorProps } from "@mantine/core";
import { ReactNode } from "react";

interface Props extends MantineIndicatorProps {
  children?: ReactNode;
}

const Indicator = ({ children, ...props }: Props) => {
  return <MantineIndicator {...props}>{children}</MantineIndicator>;
};

export default Indicator;
